import { Collapse, Input } from "antd";
import React, { FC, useEffect, useState } from "react";
import "./treeSelectComponent.scss";
import { CaretDownOutlined,CheckSquareFilled } from "@ant-design/icons";
import { treeOptions } from "../../../views/Students";
const { Panel } = Collapse;
interface TreeSelectComponentProps {
  data: any[];
  forForm?: boolean;
  title?: string;
  onSelect?: (value: any) => void
}
const TreeSelectComponent: FC<TreeSelectComponentProps> = ({
  forForm = false,
  data,
  title,
  onSelect
}) => {
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState<any[]>([]);
  const [selectedItems, setSelectedItems] = useState<any[]>([])
  const renderDropdown = (items: any[]) => {
    return items.map((value, index) => {
      return (
        <Collapse ghost key={"TREE"+index}>
          {Array.isArray(value.children) && value.children.length ? (
            <Panel
              header={
                <div className="tree-select-panel__header">
                <p>{value.title}</p>
                <div onClick={() => onSelectItem(value)}>
                {selectedItems.filter(data => data.value == value.value).length ? (
                  <CheckSquareFilled className="checkbox__check" />
                ) : (
                  <div className="checkbox__uncheck"></div>
                )}
                </div>
                
              </div>
              }
              key={index}
              className="tree-select__panel"
            >
              {renderDropdown(value.children)}
            </Panel>
          ) : (
            <div className="flex align-center space-between pr-16">
              <p className="tree-select-dropdown__value">{value.title}</p>
              <div onClick={() => {}}>
              {selectedItems.filter(data => data.value == value.value).length ? (
                <CheckSquareFilled className="checkbox__check" />
              ) : (
                <div className="checkbox__uncheck"></div>
              )}
              </div>
           
            </div>
          )}
        </Collapse>
      );
    });
  };

  // const nestedSeach = (items: any) => {

  //   const arrayFilter = items.filter((item: any, index: number) => {
  //     if(Array.isArray(item.children) && item.children.length){
  //       nestedSeach(item.children)
  //     } else {
  //       return item.title.toLowerCase().indexOf(search.toLowerCase()) > -1
  //     }
  //   });

  // };

  const onSelectItem = (item: any) => {
    let selected = selectedItems
    item.children?.map((v: any, i: number) => {
      selected.push(v)
      setSelectedItems([...selected])
      if(Array.isArray(v?.children) && v?.children?.length) {
        onSelectItem(v.children)
      } else {
        console.log(v)
      }
    })
    console.log(selectedItems)
  }

  useEffect(() => {
    console.log(searchResult);
  }, [searchResult]);

  return (
    <div className="tree-select__container">
      <p className="tree-select__title">{title && title}</p>
      <Input
        placeholder="Search"
        className="tree-select__input"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          //  nestedSeach(treeOptions)
        }}
      />
      <div
        className={
          forForm ? "tree-select__dropdown" : "tree-select-form__dropdown"
        }
      >
        {search === "" ? renderDropdown(data) : <div></div>}
      </div>
    </div>
  );
};
export default TreeSelectComponent;

{
  /* {treeOptions.map((parentValue, parentIndex) => {
          return parentValue.children.length > 0 ? (
            <Collapse ghost>
              <Panel header={parentValue.title} key={parentIndex}>
                <Collapse ghost>
                  {parentValue.children?.map((childValue, childIndex) => {
                    return childValue.childr en.length > 0 ? (
                      <Panel header={childValue.title} key={childIndex}>
                        {childValue.children.length > 0 ? (
                          <Collapse ghost>
                            {childValue.children.map(
                              (superChildValue, superChildIndex) => {
                                return <div>{superChildValue.title}</div>;
                              }
                            )}
                          </Collapse>
                        ) : (
                          <div>{childValue.title}</div>
                        )}
                      </Panel>
                    ) : (
                      <div>{childValue.title}</div>
                    );
                  })}
                </Collapse>
              </Panel>
            </Collapse>
          ) : (
            <div>{parentValue.title}</div>
          );
        })} */
}
